var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPortfolio = function SvgPortfolio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 26,
    height: 26,
    fill: "current",
    viewBox: "0 0 96.704 96.704"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.609 46.765h-31.13c-.604 0-1.094.49-1.094 1.093v13.5a2.19 2.19 0 0 1-2.187 2.187H35.505a2.19 2.19 0 0 1-2.187-2.187v-13.5c0-.604-.489-1.093-1.094-1.093H1.093c-.604 0-1.093.49-1.093 1.093v44.796c0 .604.489 1.093 1.093 1.093h94.516c.604 0 1.095-.489 1.095-1.093V47.858c0-.603-.49-1.093-1.095-1.093"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.27 58.109c.5 0 .904-.404.904-.903v-8.37c0-.5-.404-.904-.904-.904H40.434c-.5 0-.904.405-.904.904v8.37c0 .5.404.903.904.903zM95.609 14.3H65.436V6.237a3.28 3.28 0 0 0-3.279-3.28H34.548a3.28 3.28 0 0 0-3.28 3.28V14.3H1.093C.489 14.3 0 14.79 0 15.394v25.11c0 .604.489 1.093 1.093 1.093h94.516c.604 0 1.095-.489 1.095-1.093v-25.11c0-.604-.49-1.094-1.095-1.094m-57.78-4.783h21.047V14.3H37.829z"
  })));
};
export default SvgPortfolio;